import script from "./IfcIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./IfcIcon.vue?vue&type=script&setup=true&lang=ts"

import "./IfcIcon.vue?vue&type=style&index=0&id=c2b97f46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b97f46"]])

export default __exports__